import { useEffect, useState } from "react";
import { ExternalLink, Handshake } from "lucide-react";
import { getTripPartners, goUrl } from "@/lib/api";
import { track } from "@/lib/analytics";
import { useLang } from "@/i18n";

export const CATEGORY_LABELS = {
  flights: "Voli", hotels: "Alloggi", experiences: "Esperienze", transport: "Trasporti",
  car_rental: "Noleggio auto", insurance: "Assicurazione", other: "Altro",
};

export const PartnersBox = ({ tripId, dates }) => {
  const { t } = useLang();
  const [items, setItems] = useState([]);
  useEffect(() => { getTripPartners(tripId).then(setItems).catch(() => setItems([])); }, [tripId]);
  if (!items.length) return null;
  return (
    <div data-testid="partners-box" className="no-print mt-6 rounded-3xl border border-amber-100 bg-amber-50/40 p-8">
      <div className="flex flex-wrap items-center gap-3">
        <span className="grid h-11 w-11 place-items-center rounded-2xl bg-white text-amber-700"><Handshake className="h-5 w-5" /></span>
        <h4 className="font-display text-xl font-semibold text-gray-900">{t("Partner consigliati")}</h4>
        <span data-testid="partners-affiliate-badge" className="rounded-full bg-amber-100 px-3 py-1 text-xs font-semibold uppercase tracking-widest text-amber-800">{t("Link affiliati")}</span>
      </div>
      <p data-testid="partners-disclaimer" className="mt-3 text-sm text-gray-600">
        {t("Proposte commerciali separate dal TS Impact Score, che non è influenzato dalle commissioni. TripSaver può ricevere una commissione, senza costi aggiuntivi per te.")}
      </p>
      <div className="mt-6 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {items.map((p) => (
          <a key={p.id} data-testid={`partner-link-${p.id}`} href={goUrl(tripId, p.id, null, dates)} onClick={() => track("affiliate_click", { partner: p.name, category: p.category, platform: p.platform })} target="_blank" rel="noopener noreferrer sponsored"
            className="group flex flex-col rounded-2xl bg-white p-5 ring-1 ring-amber-100 transition-[box-shadow,transform] hover:-translate-y-0.5 hover:shadow-md">
            <span className="text-xs font-semibold uppercase tracking-widest text-amber-700">{t(CATEGORY_LABELS[p.category] || p.category)}</span>
            <span className="mt-1 font-semibold text-gray-900">{p.name}</span>
            {p.description && <span className="mt-1 flex-1 text-sm text-gray-600">{p.description}</span>}
            <span className="mt-3 inline-flex items-center gap-1.5 text-sm font-semibold text-emerald-700">{t("Scopri l'offerta")}<ExternalLink className="h-3.5 w-3.5" /></span>
          </a>
        ))}
      </div>
    </div>
  );
};
